import { create } from 'zustand';

/** iOS install-instructions dialog — a store (like helpDialogStore) because
 *  the trigger lives in the Thêm drawer, which closes itself on selection:
 *  a dialog owned by the drawer would unmount with it. */
export const useInstallHelpStore = create<{ open: boolean; setOpen: (v: boolean) => void }>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
